export default __webpack_public_path__ + "3293f2faa100ccaf6d1e67b745d59e52.png";